import { Flex, HStack, Box, StackProps } from "@chakra-ui/layout";
import {
  forwardRef, Grid,
  Icon,
  Image,
  Modal, ModalBody,
  ModalCloseButton,
  ModalContent, ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { ClockIcon } from "@components/Icons/ClockIcon";
import moment from "moment";
import React from "react";
import getReadingTime from "@utils/readingTime";
import share from "@images/share.svg";
import facebook from "@images/facebook-filled.svg";
import twitter from "@images/twitter.svg";
import messenger from "@images/messenger.svg";
import { EmailIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { preparePostUrl } from "@core/utils";
import { SharePost } from "../../../SharePost/sharePost";

export const MetaCard = forwardRef<StackProps & {isDate?: boolean}, "div">(
  ({ article, article: { content, publicationDate, title, readingTime }, isDate = true, ...props }, ref) => {
    return (
      <HStack ref={ref} {...props}>
        <Flex w="100%" gridGap="20px">
            {
              isDate && (
                <Text color="#A0A0A0">
                  {moment(publicationDate).format("D MMMM YYYY")}
                </Text>
              )
            }
            <Box color="#A0A0A0">
              <ClockIcon />
              {readingTime} min.
            </Box>
            <SharePost article={article} title={title} d={{base: "block", md: "none"}} />
        </Flex>

      </HStack>
    );
  }
);
